module.exports = __webpack_public_path__ + "media/soundtrack.9de0a0f9.mp3";